module.exports = __webpack_public_path__ + "static/media/ivy-bg.737e9b22.mp4";